
const config = { "1/1": "1 / 1", "3/2": "3 / 2", "16/9": "16 / 9", "4/5": "4 / 5", "1/1-parallax": "20 / 23", "3/2-parallax": "30 / 23", "16/9-parallax": "889 / 575", "4/5-parallax": "16 / 23",  }
export { config as default }